/**
 * Opens a plan link kept through sign-in (`D273`, `D262`): the first time the
 * app, signed in and past its intake, shows no sheet, a kept `?plan=` id
 * opens the PREVIEW — which reads, and imports only on its own button
 * (`T-145`). Mounted once inside the gate, like `WarmLayers`.
 *
 * A sheet already open (the review the intake's hand-off opened, say) is
 * left alone, and the id waits for it to close: a preview pushed over a
 * review would stack a second plan over the first. The intake's hand-off
 * takes the id itself when it is there at the commit, so a new account lands
 * on the preview instead of a generated plan.
 */
import { useEffect } from "react";
import { useAppSearch, useOpenLayer } from "../../app/layers";
import { takePendingPlan } from "./landing";

export function PendingSharedPlanDoor() {
  const { sheet } = useAppSearch();
  const openLayer = useOpenLayer();
  const idle = sheet === undefined;
  useEffect(() => {
    if (!idle) {
      return;
    }
    let cancelled = false;
    takePendingPlan().then((shareId) => {
      if (!cancelled && shareId !== null) {
        openLayer({ share: shareId, sheet: "shared" });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [idle, openLayer]);
  return null;
}
